import InstallPWA from './InstallPWA';
import OfflineStatus from './OfflineStatus';
import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import SignupPage from './pages/SignupPage';
import LoginPage from './pages/LoginPage';
import Logout from './Logout';
import { UserProvider } from './UserContext';
import { SpeedInsights } from "@vercel/speed-insights/react";
import ProfilePage from './pages/ProfilePage';
import Header from './Header';
import CreateRecipePage from './pages/CreateRecipePage';
import EditRecipePage from './pages/EditRecipePage';
import DeleteRecipePage from './pages/DeleteRecipePage';
import RecipeDetailsPage from './pages/RecipeDetailsPage'; // Import the missing component

function App() {
  return (
    <UserProvider>
      <InstallPWA />
      <OfflineStatus />
      <SpeedInsights />
      <Router>
        <div className="App">
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/recipes/create" element={<CreateRecipePage />} />
            <Route path="/recipes/edit/:id" element={<EditRecipePage />} />
            <Route path="/recipes/delete/:id" element={<DeleteRecipePage />} />
            <Route path="/recipes/:id" element={<RecipeDetailsPage />} />
          </Routes>
        </div>
      </Router>
    </UserProvider>
  );
}

export default App;